export default "__VITE_ASSET__f2b245ca__"